import { CANDIDATE_INPUT_INFO_TYPES, LOCAL_STORAGE_USER_LOGIN_INFO } from '@app/constants/Common';
import { Messages } from '@app/constants/Messages';
import { CANDIDATE_NATIONALITIES, checkNationalOptionsHaveExpatAndVN, COUNTRIES } from "@app/constants/Nationality";
import { AREA_OPTIONS, Provinces } from "@app/constants/Provinces";
import * as CandidateService from '@app/services/CandidateService';
import { searchAllInputInfo } from '@app/services/CandidateService';
import { checkExistsCommonFieldValues } from "@app/utils/CandidateUtils";
import { stringToOption } from "@app/utils/CommonUtils";
import { showSuccessMessageSaveData } from '@pages/candidate/Common';
import AllUserInputField from '@pages/candidate/commonview/AllUserInputField';
import React, { useEffect, useState } from 'react';
import Select from "react-select";
import { toast } from 'react-toastify';

export const CandidateLocationMode = {
    DETAIL: 1,
    RC: 2,
    SEARCH: 3,
    SEARCH_RC: 4,
}


const CandidateLocation = (props) => {
    const [isEditLocations, setIsEditLocations] = useState(false);
    const [locations, setLocations] = useState({});
    const [allLocationsInfo, setAllLocationsInfo] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [provinceOptions, setProvinceOptions] = useState([]);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const {candidateId, mode, isAllUsers, initialLocations, onChangeLocations} = props

    const updateCandidateLocations = () => {
        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        locations.allLocationsInfo = allLocationsInfo
        // Chỉ check trường sử dụng chung khi không phải RC
        if (mode !== CandidateLocationMode.RC && mode !== CandidateLocationMode.SEARCH && checkExistsCommonFieldValues(locations, userLoginInfo.id)) {
            return;
        }
        setIsLoading(true)
        CandidateService.updateCandidateLocationDetail({
            candidate_id: candidateId,
            locations: locations
        }).then((res) => {
            console.log(JSON.stringify(res))
            showSuccessMessageSaveData(res.sts_code)
            setIsEditLocations(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    useEffect(() => {
        if (initialLocations) {
            setLocations(initialLocations);
        }
    }, [initialLocations]);

    const fetchLocations = async (canId) => {
        setIsLoading(true)
        CandidateService.getCandidateLocationDetail(canId, isAllUsers).then((res) => {
            setLocations(res.content)
        }).catch((error) => {
            // toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
        const allDbLocations = await searchAllInputInfo(canId, CANDIDATE_INPUT_INFO_TYPES.Location)
        setAllLocationsInfo(allDbLocations)
    };

    useEffect(async () => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            await setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, []);

    useEffect(() => {
        if (candidateId) {
            (async () => {
                await fetchLocations(candidateId);
            })();
        }

        if (provinceOptions.length === 0) {
            let provinces = [];
            Provinces.forEach(item => {
                provinces.push({
                    value: item,
                    label: item.charAt(0).toUpperCase() + item.slice(1)
                });
            });
            setProvinceOptions(provinces);
        }
    }, [candidateId])

    useEffect(() => {
        if (mode === CandidateLocationMode.SEARCH || mode === CandidateLocationMode.SEARCH_RC) {
            setIsEditLocations(true);
        }
    }, [mode]);

    const onChangeLocalNationality = (values, allLocations) => {
        const allLocalNationalities = []
        if (allLocations && allLocations.length > 0) {
            allLocations.forEach(item => {
                // lọc ra các localtion không phải do user đang login nhập liệu.
                if (item.local_nationality && item.created_user !== userLoginInfo.id) {
                    allLocalNationalities.push({
                        value: item.local_nationality.toLowerCase(),
                        label: item.local_nationality
                    })
                }
            })
        }
        if (values) {
            values.forEach(v => {
                allLocalNationalities.push(v)
            })
        }

        if (mode !== CandidateLocationMode.SEARCH && checkNationalOptionsHaveExpatAndVN(allLocalNationalities)) {
            if (window.confirm(Messages.cannotNationalExpatAndVN) === false) {
                return;
            }
        }
        locations.local_nationality = values;
        setLocations({...locations});
        if (onChangeLocations) {
            onChangeLocations({...locations});
        }
    };
    const onChangeLocalEverWorkNationality = (values) => {
        locations.local_ever_work_nationality = values;
        setLocations({...locations});
        if (onChangeLocations) {
            onChangeLocations({...locations});
        }
    };
    const onChangeLocalOverseaOrEmail = (values, field) => {
        locations[field] = values;
        setLocations({...locations});
        if (onChangeLocations) {
            onChangeLocations({...locations});
        }
    };

    const onChangeLocalProvince = (values, field) => {
        if (field === 'rc_local_province') {
            locations.rc_local_province = values;
        } else {
            locations.local_province = values;
            locations.local_province_email = values;
        }
        setLocations({...locations});
        if (onChangeLocations) {
            onChangeLocations({...locations});
        }
    };

    const onChangeLocalProvinceEmail = (values) => {
        locations.local_province_email = values;
        setLocations({...locations});
        if (onChangeLocations) {
            onChangeLocations({...locations});
        }
    };

    const onChangeLocalArea = (values, field) => {
        if (field === 'rc_local_area') {
            locations.rc_local_area = values;
        } else {
            locations.local_area = values;
            locations.local_area_email = values;
        }
        setLocations({...locations});
        if (onChangeLocations) {
            onChangeLocations({...locations});
        }
    };

    const onChangeLocalAreaEmail = (values) => {
        locations.local_area_email = values;
        setLocations({...locations});
        if (onChangeLocations) {
            onChangeLocations({...locations});
        }
    };

    // useEffect(() => {
    //     if (onChangeLocations) {
    //         onChangeLocations({...locations});
    //     }
    // }, [locations]);

    const copyFromPersonalTab = () => {
        locations.rc_local_province = Array.from(new Set([
            ...(locations.rc_local_province || []), ...(allLocationsInfo.flatMap(item => stringToOption(item.local_province)))
        ]));
        locations.rc_local_area = Array.from(new Set([
            ...(locations.rc_local_area || []), ...(allLocationsInfo.flatMap(item => stringToOption(item.local_area)))
        ]));
        setLocations({...locations})
        if (onChangeLocations) {
            onChangeLocations({...locations});
        }
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Locations</h3>
                    {(mode !== CandidateLocationMode.SEARCH && mode !== CandidateLocationMode.SEARCH_RC) && (
                    <div className='card-tools'>
                        {isEditLocations &&
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => {
                                        setIsEditLocations(false);
                                    }}
                            >
                                Cancel
                            </button>
                        }
                        {isEditLocations && (mode === CandidateLocationMode.RC || mode === CandidateLocationMode.SEARCH_RC) &&
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => {
                                        copyFromPersonalTab();
                                    }}>
                                Copy từ tab Personal
                            </button>
                        }
                        {isEditLocations &&
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={() => {
                                        updateCandidateLocations();
                                    }}>
                                Save
                            </button>
                        }
                        {!isEditLocations &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setIsEditLocations(true);
                                    }}>
                                Edit
                            </button>
                        }
                    </div>
                    )}
                </div>
                <div className='card-body'>
                    {(mode !== CandidateLocationMode.RC && mode !== CandidateLocationMode.SEARCH_RC) &&
                        <>
                            <div className='input-group'>
                                <label className={'w-100'}>Quốc tịch</label>
                                <div style={{width: '100%'}}>
                                    <Select options={CANDIDATE_NATIONALITIES} isMulti
                                            isDisabled={!isEditLocations}
                                            value={
                                                locations.local_nationality && locations.local_nationality.length > 0 ?
                                                    locations.local_nationality : []
                                            }
                                            onChange={values => {
                                                onChangeLocalNationality(values, allLocationsInfo);
                                            }}
                                    />
                                </div>
                                <AllUserInputField arrInfo={allLocationsInfo}
                                                   field='local_nationality'/>
                            </div>
                            <div className='input-group'>
                                <label className={'w-100'}>Nước ngoài từng làm việc</label>
                                <div style={{width: '100%'}}>
                                    <Select options={COUNTRIES} isMulti
                                            isDisabled={!isEditLocations}
                                            value={
                                                locations.local_ever_work_nationality && locations.local_ever_work_nationality.length > 0 ?
                                                    locations.local_ever_work_nationality : []
                                            }
                                            onChange={values => {
                                                onChangeLocalEverWorkNationality(values);
                                            }}
                                    />
                                </div>
                                <AllUserInputField arrInfo={allLocationsInfo}
                                                   field='local_ever_work_nationality'/>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}>Location (Tỉnh)</label>
                                <div style={{width: '100%'}}>
                                    <Select options={provinceOptions} isMulti
                                            isDisabled={!isEditLocations}
                                            value={locations.local_province}
                                            onChange={value => {
                                                onChangeLocalProvince(value);
                                            }}
                                    />
                                </div>
                                <AllUserInputField arrInfo={allLocationsInfo}
                                                   field='local_province'/>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Location Tỉnh
                                    (Email)</b></label>
                                <div style={{width: '100%'}}>
                                    <Select options={provinceOptions} isMulti
                                            isDisabled={!isEditLocations}
                                            value={locations.local_province_email}
                                            onChange={value => {
                                                onChangeLocalProvinceEmail(value);
                                            }}
                                    />
                                </div>
                                <AllUserInputField arrInfo={allLocationsInfo}
                                                   field='local_province_email'/>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Location Miền</b></label>
                                <div style={{width: '100%'}}>
                                    <Select options={AREA_OPTIONS} isMulti
                                            isDisabled={!isEditLocations}
                                            value={locations.local_area}
                                            onChange={value => {
                                                onChangeLocalArea(value);
                                            }}
                                    />
                                </div>
                                <AllUserInputField arrInfo={allLocationsInfo}
                                                   field='local_area'/>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Location Miền (Email)</b></label>
                                <div style={{width: '90%'}}>
                                    <Select options={AREA_OPTIONS} isMulti
                                            isDisabled={!isEditLocations}
                                            value={locations.local_area_email}
                                            onChange={value => {
                                                onChangeLocalAreaEmail(value);
                                            }}
                                    />
                                </div>
                                <AllUserInputField arrInfo={allLocationsInfo}
                                                   field='local_area_email'/>
                            </div>
                            {mode !== CandidateLocationMode.SEARCH && (
                                <>
                                
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Location Oversea</b></label>
                                <div style={{width: '90%'}}>
                                    <Select options={COUNTRIES} isMulti
                                            isDisabled={!isEditLocations}
                                            value={
                                                locations.local_oversea && locations.local_oversea.length > 0 ?
                                                    locations.local_oversea : []
                                            }
                                            onChange={values => {
                                                onChangeLocalOverseaOrEmail(values, 'local_oversea');
                                            }}
                                    />
                                </div>
                                <AllUserInputField arrInfo={allLocationsInfo}
                                                   field='local_Oversea'/>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Location Oversea (Email)</b></label>
                                <div style={{width: '90%'}}>
                                    <Select options={COUNTRIES} isMulti
                                            isDisabled={!isEditLocations}
                                            value={
                                                locations.local_oversea_email && locations.local_oversea_email.length > 0 ?
                                                    locations.local_oversea_email : []
                                            }
                                            onChange={values => {
                                                onChangeLocalOverseaOrEmail(values, 'local_oversea_email');
                                            }}
                                    />
                                </div>
                                <AllUserInputField arrInfo={allLocationsInfo}
                                                   field='local_oversea_email'/>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Location Note</b></label>
                                <input type='text'
                                       disabled={!isEditLocations}
                                       className={`form-control`}
                                       value={locations.local_note}
                                       name={'local_note'}
                                       onChange={event => {
                                           locations.local_note = event.target.value;
                                           setLocations({...locations});
                                           if (onChangeLocations) {
                                               onChangeLocations({...locations});
                                           }
                                       }}/>
                                <AllUserInputField arrInfo={allLocationsInfo}
                                                   field='local_note'/>
                            </div>
                            </>
                            )}
                        </>
                    }

                    {(mode === CandidateLocationMode.RC || mode === CandidateLocationMode.SEARCH_RC) &&
                        <>
                            <div className='input-group'>
                                <label className={'w-100'}>Location Tỉnh (RC)</label>
                                <div style={{width: '100%'}}>
                                    <Select options={provinceOptions} isMulti
                                            isDisabled={!isEditLocations}
                                            value={locations.rc_local_province}
                                            onChange={value => {
                                                onChangeLocalProvince(value, 'rc_local_province');
                                            }}
                                    />
                                </div>
                                {/*<AllUserInputField arrInfo={allLocationsInfo}*/}
                                {/*                   field='rc_local_province'/>*/}
                            </div>

                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Location Miền (RC)</b></label>
                                <div style={{width: '100%'}}>
                                    <Select options={AREA_OPTIONS} isMulti
                                            isDisabled={!isEditLocations}
                                            value={locations.rc_local_area}
                                            onChange={value => {
                                                onChangeLocalArea(value, 'rc_local_area');
                                            }}
                                    />
                                </div>
                                {/*<AllUserInputField arrInfo={allLocationsInfo}*/}
                                {/*                   field='rc_local_area'/>*/}
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    );
};

export default CandidateLocation;
